import DOCUMENT_TYPE_CODES from '../constants/document-type-codes';

export const emptyDocument = {
  name: '',
  documentType: '',
  file: '',
};

const NOT_UNIQUE_DOCUMENTS = [DOCUMENT_TYPE_CODES.OTHER];
const PROVIDER_DOCUMENTS = [DOCUMENT_TYPE_CODES.PDF, DOCUMENT_TYPE_CODES.XML];

export const isProviderManagedDocument = (documentTypeCode, hasInvoiceProvider = false) => (
  hasInvoiceProvider && PROVIDER_DOCUMENTS.includes(documentTypeCode)
);

export const checkAlreadyUploaded = (
  method,
  { hasInvoiceProvider = false, attachableList = [] } = {},
) => {
  if (NOT_UNIQUE_DOCUMENTS.includes(method.code)) {
    return false;
  }
  if (isProviderManagedDocument(method.code, hasInvoiceProvider)) {
    return true;
  }
  return attachableList.some(
    (attachable) => attachable.label === method.name,
  );
};

export const getUploadDocumentType = (document) => {
  if (document.uploadDocumentType) {
    return document.uploadDocumentType;
  }
  if (document.code) {
    return document.code;
  }
  if (document.companyDocument?.type?.code) {
    return document.companyDocument.type.code;
  }
  return null;
};

export const checkXmlErrors = (documentType, documentName) => {
  if (documentType !== DOCUMENT_TYPE_CODES.XML && documentName.includes('.xml')) {
    return '👀 Recuerda que existe una sección para los XML de la factura';
  }
  if (documentType === DOCUMENT_TYPE_CODES.XML && !documentName.includes('.xml') && documentName) {
    return '🤔 El archivo cargado no es de tipo XML';
  }
  return false;
};
